"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var react_1 = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var Input_styles_1 = require("./Input.styles");

var defaultProps = {
  label: '',
  description: '',
  value: '',
  error: '',
  touched: false,
  className: '',
  mode: 'light',
  testId: 'Input',
  InputComponent: Input_styles_1.FormInput
};

var noop = function noop(f) {
  return f;
};

var Input =
/** @class */
function (_super) {
  __extends(Input, _super);

  function Input(props) {
    var _this = _super.call(this, props) || this;

    var value = props.value;

    var hasValueProp = _this.hasValidValue(value);

    _this.state = {
      inputValue: value,
      hasValue: hasValueProp
    };
    _this.onInputFocus = _this.onInputFocus.bind(_this);
    _this.onInputBlur = _this.onInputBlur.bind(_this);
    _this.onInputChange = _this.onInputChange.bind(_this);
    _this.handleAutofill = _this.handleAutofill.bind(_this);
    return _this;
  }

  Input.prototype.componentDidUpdate = function (prevProps) {
    var value = this.props.value;

    if (prevProps.value !== value) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        hasValue: this.hasValidValue(value)
      });
    }
  };

  Input.prototype.handleAutofill = function (e) {
    if (e.animationName === 'onAutoFillStart') {
      this.setState({
        hasValue: true
      });
    }

    if (e.animationName === 'onAutoFillCancel') {
      var inputValue = this.state.inputValue;
      this.setState({
        hasValue: this.hasValidValue(inputValue)
      });
    }
  };

  Input.prototype.onInputBlur = function (e) {
    var onBlur = this.props.onBlur;
    if (onBlur) onBlur(e);
  };

  Input.prototype.onInputChange = function (e) {
    var sanitize = this.props.sanitize;
    var sanitizeFn = sanitize || noop;
    var newValue = sanitizeFn(e.target.value);
    this.setState({
      inputValue: newValue,
      hasValue: this.hasValidValue(newValue)
    });
  };

  Input.prototype.onInputFocus = function (e) {
    var onFocus = this.props.onFocus;
    if (onFocus) onFocus(e);
  }; // eslint-disable-next-line class-methods-use-this


  Input.prototype.hasValidValue = function (v) {
    return v.toString().length > 0;
  };

  Input.prototype.render = function () {
    var _a = this.props,
        id = _a.id,
        label = _a.label,
        description = _a.description,
        onChange = _a.onChange,
        onBlur = _a.onBlur,
        value = _a.value,
        error = _a.error,
        touched = _a.touched,
        testId = _a.testId,
        className = _a.className,
        children = _a.children,
        mode = _a.mode,
        width = _a.width,
        inputRef = _a.inputRef,
        InputComponent = _a.InputComponent,
        restProps = __rest(_a, ["id", "label", "description", "onChange", "onBlur", "value", "error", "touched", "testId", "className", "children", "mode", "width", "inputRef", "InputComponent"]);

    var _b = this.state,
        inputValue = _b.inputValue,
        hasValue = _b.hasValue;
    var hasValueProp = this.hasValidValue(value);
    var isValid = !error && touched && hasValueProp;
    var shouldShowError = error && touched;
    var isFieldPopulated = hasValue || hasValueProp;
    var hasDescription = (description || '').length > 0;
    var classNames = classnames_1.default({
      'show-error-icon': shouldShowError,
      'is-populated': hasValue || hasValueProp,
      'has-label': label === null || label === void 0 ? void 0 : label.length
    });

    var inputProps = __assign({
      id: id,
      value: onChange ? value : inputValue,
      onBlur: onBlur || this.onInputBlur,
      onChange: onChange || this.onInputChange,
      onFocus: this.onInputFocus,
      label: label,
      onAnimationStart: this.handleAutofill
    }, restProps);

    return react_1.default.createElement(Input_styles_1.InputWrapper, {
      width: width,
      className: className,
      "data-testid": testId
    }, react_1.default.createElement(Input_styles_1.InputContainer, {
      className: className
    }, react_1.default.createElement(InputComponent, __assign({
      type: "text",
      className: classNames,
      mode: mode,
      ref: inputRef
    }, inputProps)), react_1.default.createElement(Input_styles_1.Label, {
      htmlFor: id
    }, label), isValid && isFieldPopulated && react_1.default.createElement(Input_styles_1.CheckmarkIcon, null), shouldShowError && react_1.default.createElement(Input_styles_1.ErrorIcon, null), children), shouldShowError && react_1.default.createElement(Input_styles_1.ErrorMessageContainer, null, error), hasDescription && react_1.default.createElement(Input_styles_1.DescriptionContainer, null, description));
  };

  Input.defaultProps = defaultProps;
  return Input;
}(react_1.PureComponent);

exports.Input = Input;
exports.default = react_1.default.forwardRef(function (props, ref) {
  return react_1.default.createElement(Input, __assign({}, props, {
    inputRef: ref
  }));
});